import React from 'react';
import { cn } from '@/lib/utils';

const CreativesLayout = ({
    children,
    preview,
    mobilePreview, // If undefined, defaults to 'preview'. If null, hides mobile preview.
    className,
    fullHeight = false,
    stickyOffsetClassName = 'top-16',
}) => {
    const activeMobilePreview = mobilePreview === undefined ? preview : mobilePreview;

    return (
        <div className={cn(
            'bg-background flex flex-col lg:flex-row',
            fullHeight ? 'h-full min-h-0' : 'min-h-screen',
        )}>
            {/* MOBILE PREVIEW (Sticky Top) */}
            {activeMobilePreview && (
                <div className={cn(
                    'lg:hidden w-full bg-zinc-900 border-b relative z-30 sticky shrink-0 shadow-lg overflow-hidden',
                    stickyOffsetClassName,
                )}>
                    <div className="aspect-video max-h-[35vh] w-full flex items-center justify-center">
                        {activeMobilePreview}
                    </div>
                </div>
            )}

            {/* LEFT PANEL: Controls */}
            <div className={cn(
                'w-full lg:w-[450px] xl:w-[500px] flex flex-col border-r bg-card z-10 relative',
                fullHeight && 'min-h-0',
            )}>
                <div className={cn(
                    'p-6 pb-24 lg:pb-6',
                    fullHeight && 'flex-1 min-h-0 overflow-y-auto',
                    className,
                )}>
                    {children}
                </div>
            </div>

            {/* RIGHT PANEL: Immersive Canvas (Sticky) */}
            <div className="hidden lg:flex flex-1 bg-zinc-50/50 relative">
                <div className={cn(
                    'sticky w-full flex flex-col overflow-hidden',
                    stickyOffsetClassName,
                    fullHeight ? 'h-full min-h-0' : 'h-[calc(100vh-4rem)]',
                )}>
                    <div className="relative z-10 w-full h-full flex flex-col p-6">
                        {preview}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreativesLayout;
